/** Parse `YYYY-MM-DD` as local calendar date for Flatpickr (avoids UTC shift). */
export function ymdToLocalDate(ymd: string): Date | "" {
  if (!ymd?.trim()) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(ymd.trim());
  if (!m) return "";
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

export function localDateToYmd(d: Date): string {
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

/** `YYYY-MM-DDTHH:mm` in local wall time (matches prior datetime-local input). */
export function localDateTimeToPickerString(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function pickerDateTimeStringToDate(s: string): Date | "" {
  if (!s?.trim()) return "";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? "" : d;
}
